import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subscribeBoxA",
  "use": "subscribeBoxA-usage",
  "viewBox": "0 0 942.2 443.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 942.2 443.3\" id=\"subscribeBoxA\">\n\t<path d=\"M112.8 108.7C168.4-18.6 264.7-21 320.7 35c73.2 78 62.7 172.4 37.3 233-42.2 100.4-137.2 208.8-237.6 165.6C38.1 398 57.2 236 112.8 108.7z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol